/**
 * getCurrentTime returns current time, adjusted with time zone offset
 * @param serverDate {Date} date on the server
 * @param timeZoneOffset {Number} time zone as a number
 * @returns current time {Date} current time, adjusted with time zone offset
 */
export function getCurrentTime(serverDate, timeZoneOffset) {
    let currentTime = new Date(serverDate);
    let currentTimeZone = timeZoneOffset.toString();
    if (currentTimeZone.indexOf(".") === -1) {
        currentTime.setHours(currentTime.getHours() + parseInt(currentTimeZone));
        return currentTime;
    }
    let hoursDiff = parseInt(currentTimeZone);
    let minutesDiff = (parseFloat(currentTimeZone) - hoursDiff) * 60;
    currentTime.setHours(currentTime.getHours() + hoursDiff, currentTime.getMinutes() + minutesDiff);
    return currentTime;
}
//# sourceMappingURL=CurrentTimeHelper.js.map